package com.ijoin.data.storage

import kotlinx.browser.localStorage

actual class TokenManager {
    actual fun saveToken(token: String) {
        localStorage.setItem(TOKEN_KEY, token)
    }

    actual fun getToken(): String? {
        return localStorage.getItem(TOKEN_KEY)
    }

    actual fun saveRefreshToken(refreshToken: String) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    }

    actual fun getRefreshToken(): String? {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    }

    actual fun saveUserId(userId: Long) {
        localStorage.setItem(USER_ID_KEY, userId.toString())
    }

    actual fun getUserId(): Long? {
        return localStorage.getItem(USER_ID_KEY)?.toLongOrNull()
    }

    actual fun clearUserId() {
        localStorage.removeItem(USER_ID_KEY)
    }

    actual fun clearToken() {
        localStorage.removeItem(TOKEN_KEY)
    }

    actual fun clearRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    }

    actual fun isAuthenticated(): Boolean {
        return getToken() != null
    }

    actual fun savePendingLegalAcceptance(versions: Map<String, String>) {
        val json = versions.entries.joinToString(",") { "\"${it.key}\":\"${it.value}\"" }
        localStorage.setItem(PENDING_LEGAL_KEY, "{$json}")
    }

    actual fun getPendingLegalAcceptance(): Map<String, String>? {
        val json = localStorage.getItem(PENDING_LEGAL_KEY) ?: return null
        return try {
            // Simple JSON parsing for {"key":"value"} format
            json.trim().removeSurrounding("{", "}")
                .split(",")
                .filter { it.isNotBlank() }
                .associate { pair ->
                    val (k, v) = pair.split(":", limit = 2)
                    k.trim().removeSurrounding("\"") to v.trim().removeSurrounding("\"")
                }
        } catch (e: Exception) {
            null
        }
    }

    actual fun clearPendingLegalAcceptance() {
        localStorage.removeItem(PENDING_LEGAL_KEY)
    }

    companion object {
        private const val TOKEN_KEY = "auth_token"
        private const val REFRESH_TOKEN_KEY = "refresh_token"
        private const val USER_ID_KEY = "user_id"
        private const val PENDING_LEGAL_KEY = "pending_legal_acceptance"
    }
}
